export default class FdxRedirectController {
    
}